<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      {{ "ORDER_UPSALE.TITLE" | translate }}
    </div>
    <div class="panel-header-actions flex-row-center-center">
      <button
        mat-icon-button
        type="button"
        class="panel-close-btn"
        (click)="close()"
        aria-label="Close panel"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="panel-body">
    <div class="upsale-for-product mat-caption">
      {{ "ORDER_UPSALE.FOR_PRODUCT" | translate }} : {{ productName }}
    </div>

    <div *ngIf="isLoading" class="flex-column-center-center fxFlex-100p">
      <mat-spinner [diameter]="28"></mat-spinner>
    </div>

    <div
      *ngIf="!isLoading && !hasAnyOption()"
      class="upsale-empty flex-column-center-center"
    >
      {{ "ORDER_UPSALE.EMPTY" | translate }}
    </div>

    <div *ngIf="!isLoading">
      <div *ngFor="let question of questions" class="upsale-question">
        <div class="upsale-question-name text-bold">{{ question.name }}</div>

        <div *ngFor="let group of question.groups" class="upsale-group">
          <div *ngIf="group.name" class="upsale-group-name mat-caption">
            {{ group.name }}
          </div>

          <div
            *ngFor="let option of group.options"
            class="upsale-option flex-row-space-between-center"
          >
            <div class="upsale-option-infos">
              <div class="upsale-option-name">
                {{ option.target.name_internal || option.target.name || option.name }}
              </div>
              <div class="upsale-option-details mat-caption">
                {{
                  (option.target.type === "material"
                    ? "ORDER_UPSALE.MATERIAL"
                    : "ORDER_UPSALE.PRODUCT"
                  ) | translate
                }}
                | {{ option.target.price_label }}
              </div>
            </div>

            <button
              mat-icon-button
              type="button"
              [disabled]="option.adding"
              matTooltip="{{ 'ORDER_UPSALE.ADD' | translate }}"
              (click)="onAddOption(option)"
            >
              <mat-spinner
                *ngIf="option.adding"
                [diameter]="18"
              ></mat-spinner>
              <mat-icon *ngIf="!option.adding && !option.added">add</mat-icon>
              <mat-icon *ngIf="!option.adding && option.added" class="upsale-added-icon"
                >check</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
